import { Routes } from '@angular/router';
import { AdvertiserSearchComponent } from './advertiser/advertiser-search/advertiser-search.component';
import { AdvertiserPageComponent } from './advertiser/advertiser-details/advertiser-page/advertiser-page.component';
import { ReceiptSearchComponent } from './receipts/receipt-search/receipt-search.component';
import { ReceiptDetailsComponent } from './receipts/receipt-details/receipt-details.component';
import { MultiCampaignEditComponent } from './advertiser/advertiser-details/advertiser-campaigns/multi-campaign-edit/multi-campaign-edit.component';
import { PunchCardCampaignEditComponent } from './advertiser/advertiser-details/advertiser-campaigns/punch-card-campaign-edit/punch-card-campaign-edit.component';
import { LuckyDrawCampaignEditComponent } from './advertiser/advertiser-details/advertiser-campaigns/lucky-draw-campaign-edit/lucky-draw-campaign-edit.component';
import { StaffCampaignEditComponent } from './advertiser/advertiser-details/advertiser-campaigns/staff-campaign-edit/staff-campaign-edit.component';
import { InfoCampaignEditComponent } from './advertiser/advertiser-details/advertiser-campaigns/info-campaign-edit/info-campaign-edit.component';
import { StaffPointCampaignEditComponent } from './advertiser/advertiser-details/advertiser-campaigns/staff-point-campaign-edit/staff-point-campaign-edit.component';
import { OpenerCampaignEditComponent } from './advertiser/advertiser-details/advertiser-campaigns/opener-campaign-edit/opener-campaign-edit.component';
import { ReceiptCodeSearchComponent } from './receipt-codes/receipt-code-search/receipt-code-search.component';
import { ReceiptCodeGenerateSampleComponent } from './receipt-codes/receipt-code-generate-sample/receipt-code-generate-sample.component';
import { SafeBoxSearchComponent } from './safe-box/safe-box-search/safe-box-search.component';
import { authGuard, LoginComponent } from 'wecheer-amplify';
import { PermissionGuard } from './common/guards/permission.guard';
import { PERMISSION } from './const/permission';
import { AdvertiserSettingsComponent } from './advertiser/advertiser-details/advertiser-settings/advertiser-settings.component';
import { AdvertiserMigrationCampaignsComponent } from './advertiser/advertiser-details/advertiser-migration-campaigns/advertiser-migration-campaigns.component';

export const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'unauthorized', loadComponent: () => import('./pages/unauthorized/unauthorized.component').then(m => m.UnauthorizedComponent) },
  { path: '', redirectTo: 'fraud-detection', pathMatch: 'full' },
  {
    path: '', canActivate: [authGuard, PermissionGuard], data: { permission: PERMISSION.CAMPAIGNMANAGEMENT_READ },
    children: [
      {
        path: 'advertisers', data: { breadcrumb: { label: 'Search advertiser' } },
        children: [
          { path: '', component: AdvertiserSearchComponent },
          { path: ':id', component: AdvertiserPageComponent, data: { breadcrumb: { label: 'Advertiser details' } } },
          { path: ':id/settings', component: AdvertiserSettingsComponent, data: { breadcrumb: { label: 'Advertiser settings' } } },
          {
            path: ':id/migration-campaigns',
            component: AdvertiserMigrationCampaignsComponent,
            canActivate: [PermissionGuard],
            data: {
              breadcrumb: { label: 'Migration Campaigns' },
              permissions: [PERMISSION.CAMPAIGNMANAGEMENT_WRITE, PERMISSION.CAMPAIGN_CREATE]
            }
          }
        ]
      },
      {
        path: 'receipts', data: { breadcrumb: { label: 'Search receipt' } },
        children: [
          {
            path: '', component: ReceiptSearchComponent,
            canActivate: [PermissionGuard],
            data: {
              permissions: [PERMISSION.CAMPAIGNMANAGEMENT_READ],
            },
          },
          {
            path: ':id', component: ReceiptDetailsComponent,
            canActivate: [PermissionGuard],
            data: {
              breadcrumb: { label: 'Receipt details' },
              permissions: [PERMISSION.CAMPAIGNMANAGEMENT_READ],
            }
          }
        ]
      },
      {
        path: 'receipt-codes', data: { breadcrumb: { label: 'Search receipt codes' } },
        children: [
          {
            path: '', component: ReceiptCodeSearchComponent,
            canActivate: [PermissionGuard],
            data: {
              permissions: [PERMISSION.CAMPAIGNMANAGEMENT_READ],
            },
          },
          {
            path: 'generate-sample', component: ReceiptCodeGenerateSampleComponent,
            canActivate: [PermissionGuard],
            data: {
              breadcrumb: { label: 'Generate sample' },
              permissions: [PERMISSION.CAMPAIGNMANAGEMENT_WRITE, PERMISSION.CAMPAIGN_CREATE],
            }
          }
        ]
      },
      {
        path: 'multi-campaign-edit',
        children: [
          { path: ':advertiserId/:campaignId', component: MultiCampaignEditComponent, data: { breadcrumb: { label: 'Multi campaign edit' } } }
        ]
      },
      {
        path: 'staff-campaign-edit',
        children: [
          { path: ':advertiserId/:campaignId', component: StaffCampaignEditComponent, data: { breadcrumb: { label: 'Staff campaign edit' } } }
        ]
      },
      {
        path: 'punch-card-campaign-edit',
        data: { breadcrumb: { label: 'Edit Punch Card Campaign' } },
        children: [
          { path: ':advertiserId/:campaignId', component: PunchCardCampaignEditComponent, data: { breadcrumb: { label: 'PunchCard campaign edit' } } }
        ]
      },
      {
        path: 'lucky-draw-campaign-edit',
        children: [
          { path: ':advertiserId/:campaignId', component: LuckyDrawCampaignEditComponent, data: { breadcrumb: { label: 'LuckyDraw campaign edit' } } }
        ]
      },
      {
        path: 'info-campaign-edit',
        children: [
          { path: ':advertiserId/:campaignId', component: InfoCampaignEditComponent, data: { breadcrumb: { label: 'Info campaign edit' } } }
        ]
      },
      {
        path: 'staff-point-campaign-edit',
        children: [
          { path: ':advertiserId/:campaignId', component: StaffPointCampaignEditComponent, data: { breadcrumb: { label: 'Staff point campaign edit' } } }
        ]
      },
      {
        path: 'opener-campaign-edit',
        children: [
          { path: ':advertiserId/:campaignId', component: OpenerCampaignEditComponent, data: { breadcrumb: { label: 'Opener campaign edit' } } }
        ]
      },
      {
        path: 'safeboxes',
        data: { breadcrumb: { label: 'Safeboxes' } },
        children: [
          { path: '', component: SafeBoxSearchComponent }
        ]
      },
      {
        path: 'fraud-detection',
        data: { breadcrumb: { label: 'Fraud detection' } },
        loadComponent: () => import('./fraud-detection/fraud-detection-search/fraud-detection-search.component').then(m => m.FraudDetectionSearchComponent),
      }
    ]
  }
];
